
async function getMetaobjectBreadcrumbs(hasNextPage = true, endCursor = null, all = []) {
  const query = `
    query {
      metaobjects(type: "breadcrumb", first: 50${endCursor ? `, after: "${endCursor}"` : ''}) {
        pageInfo { hasNextPage endCursor }
        edges {
          node {
            handle
            fields { key value }
          }
        }
      }
    }
  `;
  const res = await fetch(`https://${window.Shopify.shop}/api/2024-04/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': window.theme.storefrontAPIToken
    },
    body: query
  });

  const json = await res.json();
  const edges = json?.data?.metaobjects?.edges || [];
  const pageInfo = json?.data?.metaobjects?.pageInfo;

  const breadcrumbs = edges.map(({ node }) => {
    const obj = { handle: node.handle.replace(/^breadcrumb-/, '') };
    node.fields.forEach(f => (obj[f.key] = f.value));
    return obj;
  });

  all.push(...breadcrumbs);
  return pageInfo?.hasNextPage
    ? getMetaobjectBreadcrumbs(true, pageInfo.endCursor, all)
    : all;
}


async function getCollectionTitlesByGids(gids) {
  const cacheKey = 'breadcrumb_gid_title_map';
  const cached = sessionStorage.getItem(cacheKey);
  if (cached) return JSON.parse(cached);

  const url = `https://${window.Shopify.shop}/api/2024-04/graphql.json`;
  const uniqueGids = [...new Set(gids.filter(Boolean))];
  const chunks = Array.from({ length: Math.ceil(uniqueGids.length / 50) }, (_, i) =>
    uniqueGids.slice(i * 50, i * 50 + 50)
  );

  const requests = chunks.map(chunk =>
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': window.theme.storefrontAPIToken
      },
      body: `
        query {
          nodes(ids: [${chunk.map(gid => `"${gid}"`).join(',')}]) {
            ... on Collection { id title handle }
          }
        }
      `
    }).then(r => r.json())
  );

  const responses = await Promise.all(requests);
  const map = {};

  responses.forEach(r => {
    (r.data?.nodes || []).forEach(node => {
      if (!node) return;
      const d = { title: node.title, handle: node.handle };
      [node.id, node.handle, normalize(node.handle), node.title, normalize(node.title)].forEach(k => {
        map[k] = d;
      });
    });
  });

  sessionStorage.setItem(cacheKey, JSON.stringify(map));
  return map;
}


async function loadAndRenderBreadcrumbs() {
  const breadcrumbs = await getMetaobjectBreadcrumbs();
  const wrapper = document.getElementById('breadcrumbs-wrapper');
  const container = document.querySelector('.breadcrumbs');

  if (!breadcrumbs.length || !container) {
    if (wrapper) {
      const isMobile = window.innerWidth <= 768;
      const padding = isMobile ? '14px' : '4px';
      wrapper.style.display = 'block'; 
      wrapper.style.paddingBottom = padding;
    }
    return;
  }

  const gids = breadcrumbs.flatMap(b => [b.collection_name, b.first_tier, b.second_tier]);
  const gidMap = await getCollectionTitlesByGids(gids);

  const path = window.location.pathname.split('/');
  const isCollection = path[1] === 'collections';
  const handle = normalize(isCollection ? path[2] : path.at(-1));

  const match = breadcrumbs.find(b =>
    [b.collection_name_handle, b.collection_name_title, b.collection_name].some(v => normalize(v) === handle)
  ) || breadcrumbs.find(b => normalize(b.handle) === handle);

  if (!match) {
    if (wrapper) {
      const isMobile = window.innerWidth <= 768;
      const padding = isMobile ? '14px' : '4px';
      wrapper.style.display = 'block';
      wrapper.style.paddingBottom = padding;
    }
    return;
  }

  const enrich = val => gidMap[val] || gidMap[normalize(val)] || { title: val, handle: normalize(val) };

  const enriched = {
    root: enrich(match.collection_name),
    first: enrich(match.first_tier),
    second: enrich(match.second_tier)
  };

  const items = isCollection
    ? [enriched.first, enriched.second]
    : [enriched.root, enriched.first, enriched.second];

  container.innerHTML = '';
  items.filter(i => i.title).forEach((item) => {
    const link = document.createElement('a');
    link.className = 'breadcrumbs__item is-active';
    link.href = '/collections/' + item.handle;
    link.textContent = item.title;
    link.style.setProperty('color', '#666666');
    container.appendChild(link);
    const sep = document.createElement('span');
    sep.className = 'breadcrumbs__separator';
    sep.textContent = ' / ';
    container.appendChild(sep);
  });

  wrapper.style.display = 'block';
  document.dispatchEvent(new CustomEvent('breadcrumbs:ready'));

}


function normalize(str) {
  return str?.toLowerCase().replace(/and/g, '').replace(/[-&/,]/g, '').replace(/\s+/g, '') || '';
}


document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.breadcrumbs[data-breadcrumb-type="plp"]')) {
    loadAndRenderBreadcrumbs();
  }
});
